import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBH7lbpjDjzIGMdkB1VocRw-mlhK3YvIqc",
  authDomain: "inflammascan-eb1dd.firebaseapp.com",
  projectId: "inflammascan-eb1dd",
  storageBucket: "inflammascan-eb1dd.firebasestorage.app",
  messagingSenderId: "182740797880",
  appId: "1:182740797880:web:6fdf188c8012b30e43274d",
  measurementId: "G-00LS1SSPJY"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);

export default app;


